import { Dialog, DialogPanel, DialogTitle } from '@headlessui/react'

export default function Modal({ open, setOpen, title, size, children }) {
  let maxWidth;
  let minHeight;
  switch (size) {
    case 'md':
      maxWidth = "max-w-2xl";
      break;
    case 'lg':
      maxWidth = "max-w-5xl";
      break;
    case 'full':
      maxWidth = "w-full";
      minHeight = "min-h-[95%]";
      break;
    default:
      maxWidth = "max-w-lg";
  }
  return (
    <Dialog
        open={open}
        onClose={() => setOpen(false)}
        transition
        className={`${size === "lg" ? "pt-0" : "" } z-40 fixed inset-0 flex w-screen items-center justify-center bg-black/20 p-4 transition duration-300 ease-out data-[closed]:opacity-0 overflow-y-auto overflow-x-hidden`}
    >
      <DialogPanel className={`space-y-4 bg-white p-8 w-full ${maxWidth} ${minHeight || ''}`}>
          <DialogTitle className="text-xl font-light leading-9 tracking-tight sm:text-4xl sm:leading-10">
            {title}
          </DialogTitle>
          <div>{children}</div>
      </DialogPanel>
    </Dialog>
  );
}
